import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { endpoints } from "../shared/constants/endpoints";

@Injectable({
    providedIn: 'root',
})
export class AuditsService {
    constructor(private http: HttpClient) {
    }
  
    downloadAudit(id: number, offset: number, sortBy: string = 'friendlyName', ascending: boolean = true, enableC3toC5Drugs = false, inventoryLocationsEnabled = false): Observable<Blob>  {
        return this.http.post(endpoints.audit.printAudit, {id, offset, sortBy, ascending, enableC3toC5Drugs, inventoryLocationsEnabled}, { responseType: 'blob'});
    }
    
    handleDownload(res: Blob, fileName: string): void {
        const downloadedFile = new Blob([res], {type: res.type});
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.download = fileName;
        a.href = URL.createObjectURL(downloadedFile);
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
    }

    isInventoryModifiedToday(): Observable<any> {
        const offset = new Date().getTimezoneOffset() / 60;
        return this.http.get<boolean>(endpoints.inventory.isInventoryModifiedToday + `?offset=${offset}`);
    }
}